import { styled } from "@mui/material"
import { IStyledItemProps } from "./types"

const StyledItem = styled("button", {
    shouldForwardProp: (prop) => prop !== "selected" && prop !== "open",
})<IStyledItemProps>(({ theme, selected, open }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: open ? "flex-start" : "center",
    gap: theme.spacing(2),
    width: "100%",
    border: "none",
    background: "none",
    cursor: "pointer",
    padding: open ? "10px 4px" : "10px 0",
    marginBottom: 2,
    color: selected ? (theme as any).palette.primary.light : (theme as any).palette.neutral.main,
    fontWeight: selected ? (theme as any).typography.weights.bold : (theme as any).typography.weights.regular,
    transition: theme.transitions.create("color", {
        duration: theme.transitions.duration.shortest,
    }),
    "&:hover": {
        color: (theme as any).palette.neutral.lighter,
    },
    "& .MuiSvgIcon-root": {
        fontSize: 20,
        flexShrink: 0,
        color: "inherit",
    },
}))

export { StyledItem }
